import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import getYouTubeID from "get-youtube-id";
import { bool, func, object } from "prop-types";
import React from "react";
import { disconnectObserver, getQliticsSchema, initiateNewObserver } from "../../utils";
import { WithLazy } from "../with-lazy";
var YouTube = null;
var loaderPromise = null;

function loadLibrary() {
  if (loaderPromise === null) {
    loaderPromise = import(
    /* webpackChunkName: "qtc-react-youtube" */
    "react-youtube").then(function (YT) {
      YouTube = YT["default"];
    })["catch"](function (err) {
      console.log("Failed to load react-youtube", err);
      return Promise.reject();
    });
  }

  return loaderPromise;
}

function isLibraryLoaded() {
  return YouTube !== null;
}

var CustomStoryElementYoutube = /*#__PURE__*/function (_React$Component) {
  _inherits(CustomStoryElementYoutube, _React$Component);

  var _super = /*#__PURE__*/_createSuper(CustomStoryElementYoutube);

  function CustomStoryElementYoutube(props) {
    var _this;

    _classCallCheck(this, CustomStoryElementYoutube);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "initiateObserver", function (targetElement) {
      _this.removeObserverIfExists();

      _this.intersectionObserver = new IntersectionObserver(_this.intersectionCallback, {
        threshold: 0.75
      });

      _this.intersectionObserver.observe(targetElement);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerQlitics", function (action) {
      if (_this.props.disableAnalytics === true) return false;
      var _this$props = _this.props,
          _this$props$story = _this$props.story,
          story = _this$props$story === void 0 ? {} : _this$props$story,
          _this$props$card = _this$props.card,
          card = _this$props$card === void 0 ? {} : _this$props$card,
          _this$props$element = _this$props.element,
          element = _this$props$element === void 0 ? {} : _this$props$element;

      var qliticsData = _objectSpread(_objectSpread({}, getQliticsSchema(story, card, element)), {
        "story-element-action": action
      });

      if (global.qlitics) {
        global.qlitics("track", "story-element-action", qliticsData);
      } else {
        global.qlitics = global.qlitics || function () {
          (qlitics.q = qlitics.q || []).push(arguments);
        };

        qlitics.qlitics.q.push("track", "story-element-action", qliticsData);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayCallback", function (event) {
      _this.triggerQlitics("play");

      _this.props.onPlay === "function" && _this.props.onPlay(event);
      _this.videoRef.current = event.target;

      var targetElement = _this.videoRef.current.getIframe();

      if (_this.intersectionObserver) {
        _this.intersectionObserver.observe(targetElement);
      } else {
        _this.intersectionObserver = initiateNewObserver(targetElement, _this.intersectionCallback);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "intersectionCallback", function (entries) {
      var videoInVewPort = entries === null || entries === void 0 ? void 0 : entries[0].isIntersecting;
      var player = _this.videoRef.current;
      if (videoInVewPort) player.playVideo();else {
        _this.videoPausedByObserver.current = true; // before the below line fires the pause event we set the videoPausedByObserver Ref to true, this lets the pause events callback to know that the video is not click-paused by the user but paused by the intersection observer

        player.pauseVideo();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onPauseCallback", function (event) {
      _this.triggerQlitics("pause");

      _this.props.onPause === "function" && _this.props.onPause(event);
      var videoPausedByObserver = _this.videoPausedByObserver.current;

      if (videoPausedByObserver) {
        _this.videoPausedByObserver.current = false; // This is a clean up to set videoPausedByObserver back to false
      } else {
        disconnectObserver(_this.intersectionObserver);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onEndCallback", function (event) {
      _this.triggerQlitics("end");

      _this.props.onEnd === "function" && _this.props.onEnd(event);
    });

    _defineProperty(_assertThisInitialized(_this), "triggerIframe", function () {
      _this._isMounted = true;
      loadLibrary().then(function () {
        return _this._isMounted && _this.forceUpdate();
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onPlayerReady", function (event) {
      event.target.setVolume(100);
      event.target.playVideo();
    });

    _defineProperty(_assertThisInitialized(_this), "renderVideo", function () {
      _this.triggerIframe();

      _this.setState({
        showVideo: true
      });
    });

    _this.state = {
      showVideo: false
    };
    _this.opts = {
      playerVars: {
        autoplay: 0
      }
    };
    _this.videoRef = /*#__PURE__*/React.createRef();
    _this.videoPausedByObserver = /*#__PURE__*/React.createRef(); // To check if the video is not click paused by user but paused by intersection observer, Its implemented this way because we cannot capture the click-pause event as videos are playing in iframe

    return _this;
  }

  _createClass(CustomStoryElementYoutube, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.loadIframeOnClick) {
        this.triggerIframe();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this._isMounted = false;
      disconnectObserver(this.intersectionObserver);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var youtubeIframe = function youtubeIframe() {
        return /*#__PURE__*/React.createElement(YouTube, {
          videoId: getYouTubeID(_this2.props.element.url),
          opts: _this2.opts,
          onPlay: _this2.onPlayCallback,
          onPause: _this2.onPauseCallback,
          onEnd: _this2.onEndCallback,
          onReady: _this2.onPlayerReady,
          ref: _this2.videoRef
        });
      };

      if (this.props.loadIframeOnClick) {
        return /*#__PURE__*/React.createElement("div", {
          className: "thumbnail-wrapper"
        }, !this.state.showVideo && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
          className: "youtube-playBtn",
          onClick: this.renderVideo,
          "aria-label": "Play Video"
        }), /*#__PURE__*/React.createElement("img", {
          className: "youtube-thumbnail",
          onClick: this.renderVideo,
          src: "https://i.ytimg.com/vi/".concat(getYouTubeID(this.props.element.url), "/hqdefault.jpg"),
          alt: "video"
        })), this.state.showVideo && isLibraryLoaded() && /*#__PURE__*/React.createElement("div", {
          className: "youtube-iframe-wrapper"
        }, youtubeIframe()));
      } else if (!this.props.loadIframeOnClick && isLibraryLoaded()) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, youtubeIframe());
      } else return /*#__PURE__*/React.createElement("div", null);
    }
  }]);

  return CustomStoryElementYoutube;
}(React.Component);

var StoryElementYoutube = function StoryElementYoutube(props) {
  return /*#__PURE__*/React.createElement(WithLazy, {
    margin: "0px"
  }, function () {
    return /*#__PURE__*/React.createElement(CustomStoryElementYoutube, props);
  });
};

export default StoryElementYoutube;